import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Infinity as InfinityIcon, Lightbulb, UserPlus, Award } from "lucide-react";

/* Legado do consultor: o que fica para além da edição — ideias EUREKA
   implementadas, e-ROI gerado, consultores que trouxe e cartões brancos. */
export default function LegacyCard({ playerId = null }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    const url = playerId ? `/eureka/legacy/${playerId}` : "/eureka/legacy/me";
    api.get(url).then((r) => setData(r.data)).catch(() => setData(null));
  }, [playerId]);

  if (!data) return null;

  const nothingYet = data.ideas.length === 0 && data.white_cards.length === 0 && data.recruits_count === 0;

  return (
    <div className="kw-card p-6" data-testid="legacy-card">
      <div className="flex items-center gap-3 mb-5 border-b border-[#222] pb-4">
        <InfinityIcon className="w-6 h-6 text-[#EAB308]" />
        <div>
          <div className="kw-overline">e-ROI · Eternal Return of Investment</div>
          <h2 className="font-display text-2xl font-black uppercase">Legado</h2>
        </div>
      </div>

      {nothingYet ? (
        <p className="text-sm text-[#737373]" data-testid="legacy-empty">
          Ainda sem legado registado. Submete uma ideia no EUREKA ou traz um consultor para a KW Lead —
          fica aqui para sempre.
        </p>
      ) : (
        <div className="space-y-5">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {[
              { label: "Ideias implementadas", value: data.ideas.length, color: "#22C55E" },
              { label: "Horas/mês poupadas", value: data.eroi.hours_saved_month || 0, color: "#EAB308" },
              { label: "e-ROI €/ano", value: data.eroi.euros_year || 0, color: "#E50000" },
              { label: "Cartões brancos", value: data.white_cards.length, color: "#FFFFFF" },
            ].map((k) => (
              <div key={k.label} className="border border-[#222] p-4">
                <div className="kw-overline mb-2">{k.label}</div>
                <div className="font-display text-2xl font-black leading-none" style={{ color: k.color }}>{k.value}</div>
              </div>
            ))}
          </div>

          {data.ideas.length > 0 && (
            <div data-testid="legacy-ideas">
              <div className="kw-overline mb-2">Ideias EUREKA implementadas</div>
              <div className="space-y-2">
                {data.ideas.map((i) => (
                  <div key={i.id} className="flex items-start gap-3 border-l-2 border-[#EAB308] pl-3 py-1">
                    <Lightbulb className="w-4 h-4 text-[#EAB308] mt-0.5 shrink-0" />
                    <div>
                      <div className="font-semibold text-sm">{i.title}</div>
                      <div className="text-[10px] uppercase tracking-widest text-[#737373]">
                        {i.track === "kw_lead" ? "Melhoria KW Lead" : "Melhoria Growth League"}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {data.white_cards.length > 0 && (
            <div data-testid="legacy-white-cards">
              <div className="kw-overline mb-2">Cartões brancos</div>
              <div className="space-y-1">
                {data.white_cards.map((c) => (
                  <div key={c.id} className="flex items-center gap-2 text-sm text-[#A3A3A3]">
                    <Award className="w-4 h-4 text-white shrink-0" />
                    {c.reason} <span className="text-[#737373]">· semana {c.week}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {data.recruits_count > 0 && (
            <div data-testid="legacy-recruits">
              <div className="kw-overline mb-2">Consultores que trouxe · {data.recruits_count}</div>
              <div className="flex flex-wrap gap-2">
                {data.recruits.map((r) => (
                  <span key={r.id} className="text-xs border border-[#2A2A2A] px-2 py-1 text-[#A3A3A3]">
                    <UserPlus className="w-3 h-3 inline mr-1 text-[#22C55E]" />{r.name}
                  </span>
                ))}
              </div>
              {data.recruit_bonus_approved && (
                <p className="text-[11px] uppercase tracking-widest text-[#22C55E] mt-2">
                  Padrinho Dourado autorizado · +50 pts
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
